// function searchVendors() {
//   const filter = document.getElementById("search-vendors-input").value;
//   const ul = document.getElementById("vendors-home-list");
//   const li = ul.getElementsByTagName("li");
//   for (let i = 0; i < li.length; i++) {
//     const elemText = li[i].getElementsByTagName("a")[0].text;
//     li[i].style.display =
//       !filter || elemText.toUpperCase().includes(filter.toUpperCase())
//         ? ""
//         : "none";
//   }
// }

// const searchVendorInput = $("#search-vendors-input");

// searchVendorInput.focusin(function () {
//   $("#vendors-home-list").fadeIn("fast");
// });
// searchVendorInput.focusout(function () {
//   $("#vendors-home-list").fadeOut(1000);
// });
// searchVendorInput.on("keyup", function () {
//   searchVendors();
// });

$(function () {
  var homeHeaderScroll = $('.dioptra-main-header')
  $(window).scroll(function () {
    var scroll = $(window).scrollTop()
    if (scroll >= 200) {
      homeHeaderScroll.addClass('header-scroll')
      $('#nav_container').addClass('scroll-up-nav')
      $('#live-search-main-wrapper').addClass('scrolled-search')
    } else {
      homeHeaderScroll.removeClass('header-scroll')
      $('#nav_container').removeClass('scroll-up-nav')
      $('#live-search-main-wrapper').removeClass('scrolled-search')
    }
  })
})
